/* PureEthical v29 Fase 2 - navegacao principal (computador).
   Abre o painel da categoria com o rato (com uma pequena espera, para nao abrir
   ao passar) ou com o teclado (Tab / seta para baixo); fecha com Escape, ao sair
   ou ao clicar fora. O link da categoria continua a levar a pagina da categoria.
   Painel Marcas: procura por nome (sem acentos, sem maiusculas). */
(function () {
  'use strict';
  /* menu do telemovel: as fotografias (data-pe-src) so carregam quando o menu abre */
  (function () {
    var mn = document.querySelector('.mobile-nav');
    if (!mn) return;
    function wakeMobile() {
      mn.querySelectorAll('img[data-pe-src]').forEach(function (im) {
        im.src = im.getAttribute('data-pe-src'); im.removeAttribute('data-pe-src');
      });
    }
    if (mn.classList.contains('on')) { wakeMobile(); return; }
    var mo = new MutationObserver(function () {
      if (mn.classList.contains('on') || mn.classList.contains('open') || mn.getAttribute('aria-hidden') === 'false') { wakeMobile(); mo.disconnect(); }
    });
    mo.observe(mn, { attributes: true, attributeFilter: ['class', 'aria-hidden', 'style'] });
    document.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('#burgerBtn, [aria-label="Menu"]')) wakeMobile();
    }, true);
  })();
  var items = Array.prototype.slice.call(document.querySelectorAll('[data-pe-nav]'));
  if (!items.length) return;
  var openTimer = null, closeTimer = null, current = null;
  var fine = window.matchMedia('(hover:hover) and (pointer:fine)');

  /* as fotografias do painel so carregam quando o painel e usado (no telemovel nunca) */
  function wake(item) {
    item.querySelectorAll('img[data-pe-src]').forEach(function (im) {
      im.src = im.getAttribute('data-pe-src'); im.removeAttribute('data-pe-src');
    });
  }
  var escClosing = false;
  function setOpen(item, on) {
    if (on) wake(item);
    item.classList.toggle('pe-open', on);
    var link = item.querySelector('.pe-nav-link');
    if (link) link.setAttribute('aria-expanded', on ? 'true' : 'false');
  }
  function open(item) {
    clearTimeout(closeTimer);
    if (current && current !== item) setOpen(current, false);
    current = item;
    setOpen(item, true);
  }
  function close(item) {
    if (!item) return;
    setOpen(item, false);
    if (current === item) current = null;
  }

  var nav = items[0].parentElement;
  if (nav && fine.matches) nav.addEventListener('pointerenter', function () { items.forEach(wake); }, { once: true });

  items.forEach(function (item) {
    item.addEventListener('mouseenter', function () {
      if (!fine.matches) return;
      clearTimeout(openTimer); clearTimeout(closeTimer);
      /* se ja ha um painel aberto, troca logo; senao espera um instante */
      openTimer = setTimeout(function () { open(item); }, current ? 0 : 120);
    });
    item.addEventListener('mouseleave', function () {
      if (!fine.matches) return;
      clearTimeout(openTimer);
      closeTimer = setTimeout(function () { close(item); }, 180);
    });
    item.addEventListener('focusin', function () {
      /* v30 Fase 1J: depois de Escape o foco volta ao link do menu - nao pode reabrir o painel */
      if (escClosing) { escClosing = false; return; }
      open(item);
    });
    item.addEventListener('focusout', function (e) {
      if (!item.contains(e.relatedTarget)) close(item);
    });
    var link = item.querySelector('.pe-nav-link');
    if (link) link.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowDown') {
        var first = item.querySelector('.pe-mm a, .pe-mm input');
        if (first) { e.preventDefault(); open(item); first.focus(); }
      }
    });
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape' || !current) return;
    var link = current.querySelector('.pe-nav-link');
    close(current);
    if (link && document.activeElement !== link) { escClosing = true; link.focus(); escClosing = false; }
  });
  document.addEventListener('click', function (e) {
    if (current && !current.contains(e.target)) close(current);
  });

  /* Marcas: procura (v38: funcao, porque a lista pode chegar depois - ver lazyLoad) */
  function bindBrandSearch() {
  var input = document.querySelector('[data-pe-bsearch]');
  var list = document.querySelector('[data-pe-blist]');
  if (input && list && !input.__peBound) {
    input.__peBound = true;
    var none = list.parentNode.querySelector('.pe-mm-bnone');
    var norm = function (t) { return String(t || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/[^a-z0-9]+/g, ' ').trim(); };
    var links = Array.prototype.slice.call(list.querySelectorAll('a'));
    var letters = Array.prototype.slice.call(list.querySelectorAll('.pe-mm-letter'));
    input.addEventListener('input', function () {
      var q = norm(input.value), shown = 0, seen = {};
      links.forEach(function (a) {
        var ok = !q || norm(a.textContent).indexOf(q) > -1 || norm(a.textContent).split(' ').some(function (w) { return w.indexOf(q) === 0; });
        a.hidden = !ok;
        if (ok) { shown++; seen[a.getAttribute('data-l')] = 1; }
      });
      letters.forEach(function (l) { l.hidden = !seen[l.textContent]; });
      if (none) none.hidden = shown > 0;
    });
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') {
        var first = links.filter(function (a) { return !a.hidden; })[0];
        if (first) { e.preventDefault(); window.location.href = first.href; }
      }
    });
  }
  }
  bindBrandSearch();

  /* v38 velocidade: as marcas do menu (coluna "Marcas" de cada categoria e painel Marcas A-Z) ja nao
     vem na pagina - custavam ~0,3 s no servidor em todas as paginas. Sao pedidas uma vez, a parte,
     ao cabecalho completo (Section Rendering API da Shopify) e postas no lugar dos <template data-pe-lazy>.
     Quando: o rato entra no menu, o teclado chega ao menu, ou o browser fica livre depois de carregar
     (so em ecras de computador; no telemovel este menu nao aparece). Se o pedido falhar, o menu
     continua a funcionar e o painel Marcas mostra o link para a pagina Marcas. */
  var lazyUrl = nav && nav.getAttribute('data-pe-lazy-url');
  var lazyState = 0;
  function lazyLoad() {
    if (!lazyUrl || lazyState) return;
    lazyState = 1;
    var u = lazyUrl;
    try {
      var th = window.Shopify && window.Shopify.theme;
      if (th && th.id && th.role && th.role !== 'main') u += '&preview_theme_id=' + th.id;
    } catch (e) {}
    fetch(u, { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        if (!html) { lazyState = 0; return; }
        var doc = new DOMParser().parseFromString(html, 'text/html');
        document.querySelectorAll('[data-pe-lazy]').forEach(function (slot) {
          var key = slot.getAttribute('data-pe-lazy');
          var src = doc.querySelector('[data-pe-lazy-src="' + key + '"]');
          if (slot.tagName === 'TEMPLATE') {
            if (src) slot.replaceWith(document.importNode(src, true)); else slot.remove();
          } else if (src) {
            slot.innerHTML = src.innerHTML;
            slot.removeAttribute('data-pe-lazy');
          }
        });
        lazyState = 2;
        bindBrandSearch();
        if (current) wake(current);
      })
      .catch(function () { lazyState = 0; });
  }
  if (lazyUrl) {
    if (nav) {
      nav.addEventListener('pointerenter', lazyLoad, { once: true });
      nav.addEventListener('focusin', lazyLoad, { once: true });
    }
    var big = window.matchMedia('(min-width: 1000px)');
    var idle = function () {
      if (!big.matches) return;
      if ('requestIdleCallback' in window) window.requestIdleCallback(lazyLoad, { timeout: 4000 });
      else setTimeout(lazyLoad, 1500);
    };
    if (document.readyState === 'complete') idle(); else window.addEventListener('load', idle, { once: true });
  }
})();
